import AuthFormContainer from '@/features/auth/signup/components/AuthFormContainer.tsx';
import { Skeleton } from '@/components/ui/Skeleton.tsx';

const WorkspacesSkeleton = () => (
  <AuthFormContainer title="Twoje firmy">
    <div className="flex w-full flex-col gap-6">
      <div className="flex w-full flex-col gap-3">
        <Skeleton className="h-3 w-12" />
        {[0, 1].map((i) => (
          <div
            key={i}
            className="flex w-full items-center gap-3 rounded-[14px] border border-neutral-200 p-4"
          >
            <Skeleton className="size-[34px] shrink-0 rounded-full" />
            <div className="flex min-w-0 flex-1 flex-col gap-1">
              <Skeleton className="h-5 w-40" />
              <Skeleton className="h-5 w-20 rounded-full" />
            </div>
            <Skeleton className="h-[34px] w-16" />
          </div>
        ))}
      </div>

      <div className="flex w-full flex-col items-center gap-3 border-t border-neutral-200 pt-6">
        <Skeleton className="h-12 w-full" />
        <Skeleton className="h-5 w-56" />
        <Skeleton className="h-[34px] w-28" />
      </div>
    </div>
  </AuthFormContainer>
);

export default WorkspacesSkeleton;
